import React from "react";
import "./qualityManagment.css";
import "../Dashboard/dashboard.css";
import QMa from "../../assets/images/QMa.png";
import logoContact from "../../assets/images/icon-contact.png";
import { Container, Navbar } from "react-bootstrap";
import openSectionIcon from "../../assets/images/open-secion-icon.png";
import { useDispatch, useSelector } from "react-redux";
import { changeStyle } from "../../redux/actions/design";
import clsx from 'clsx';

const QualityManagment = () => {
  const { isOpen, prevPage } = useSelector((state) => state.design);
  const dispatch = useDispatch();

  function displaySection4() {
    dispatch(changeStyle(true,4, 'home'))

    document
      .getElementById("qualityManagment")
      .setAttribute("data-boolean", "false");

    Array.from(document.getElementsByClassName("center-icon")).forEach(
      (element) => {
        element.style.visibility = "hidden";
      }
    );
    Array.from(document.getElementsByClassName("section-background")).forEach(
      (element) => {
        element.style.opacity = "1";
      }
    );
    document.getElementsByClassName("container-dashboard")[3].style.width = "100%";

    document.getElementById("reporting").style.zIndex = "1";
    document.getElementById("reporting").style.display = "none";


    document.getElementById("managment").style.zIndex = "1";
    document.getElementById("managment").style.display = "none";


    document.getElementById("qualityMonotoring").style.zIndex = "1";
    document.getElementById("qualityMonotoring").style.display = "none";
  }
  return (
    <>
        <div
          className={clsx({'div-quality-managment' : isOpen && prevPage === 'home' }, {'spacing-quality-managment' : isOpen})}
          id="qualityManagment"
          data-boolean="true"
        >
          <div className="container container-dashboard emplacement-quality-managment ">
            <div className="section-background">
              <Navbar>
                <Container>
                  <Navbar.Brand style={{ color: "#24E096" }}>
                    <img
                      alt=""
                      src={logoContact}
                      width="40"
                      height="40"
                      className="d-inline-block align-top"
                      style={{ marginRight: "15px" }}
                    />
                    Quality Managment
                  </Navbar.Brand>
                </Container>
              </Navbar>
            </div>

          </div>
        </div>
    </>
  );
};

export default QualityManagment;
